// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function EyeIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M30.914 15.595c-.044-.099-1.103-2.447-3.457-4.801C24.322 7.657 20.36 6 16 6S7.679 7.657 4.542 10.794C2.19 13.148 1.125 15.5 1.086 15.595a1 1 0 0 0 0 .812c.044.1 1.103 2.447 3.456 4.8C7.68 24.343 11.64 26 16 26s8.321-1.657 11.457-4.793c2.354-2.353 3.413-4.7 3.457-4.8a1 1 0 0 0 0-.812ZM16 24c-3.848 0-7.209-1.399-9.991-4.156A16.684 16.684 0 0 1 3.125 16a16.669 16.669 0 0 1 2.884-3.844C8.79 9.4 12.152 8 16 8s7.209 1.399 9.991 4.156A16.68 16.68 0 0 1 28.881 16c-.901 1.683-4.827 8-12.881 8Zm0-14a6 6 0 1 0 6 6 6.006 6.006 0 0 0-6-6Zm0 10a4 4 0 1 1 0-8 4 4 0 0 1 0 8Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
